import { useIntl } from 'react-intl';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

import {
	getCollaborateFirstImage,
	getCollaborateFourthImage,
	getCollaborateSecondImage,
	getCollaborateThirdImage,
} from './components/assets/localized-images';
import { JswCollaborate } from './components/jsw-collaborate';

export const JswCollaborateSection = () => {
	const intl = useIntl();

	const useGWP7617Gate = checkFeatureFlagGate(featureFlags.gwp7617JiraShortTermAiInfusionGate);

	// first item
	const firstFeatureDescriptionOld = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.first-feature-description-text',
		defaultMessage:
			'From short projects, to large cross-functional programs, Jira helps break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more.',
	});

	const firstFeatureDescriptionAI = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.first-feature-description-text-ai',
		defaultMessage:
			'From short projects, to large cross-functional programs, Jira uses AI to help break big ideas down into achievable steps. Organize work, create milestones, map dependencies and more.',
	});

	// third item
	const thirdFeatureTitleOld = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.third-feature-title-text',
		defaultMessage: 'Track work your way',
	});

	const thirdFeatureTitleAI = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.third-feature-title-text-ai',
		defaultMessage: 'Work your way',
	});

	const thirdFeatureDescriptionOld = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.third-feature-description-text',
		defaultMessage:
			'Visualize work with lists, boards, backlogs, and more. Make workflows for any process and integrate with tools you love.',
	});

	const thirdFeatureDescriptionAI = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.third-feature-description-text-ai',
		defaultMessage:
			'Keep Jira in sync with your favorite tools, customize your workflows with AI – and, stay on top of it all with lists, boards, and timeline views.',
	});

	// fourth item
	const fourthFeatureTitleOld = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.fourth-feature-title-text',
		defaultMessage: 'Optimize with insights',
	});

	const fourthFeatureTitleAI = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.fourth-feature-title-text-ai',
		defaultMessage: 'Keep your projects on track',
	});

	const fourthFeatureDescriptionOld = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.fourth-feature-description-text',
		defaultMessage:
			'Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance.',
	});

	const fourthFeatureDescriptionAI = intl.formatMessage({
		id: 'jira-product-tour.collaborate-section.fourth-feature-description-text-ai',
		defaultMessage:
			'Get visibility into project progress, understand risks, and surface insights from real-time data to help you improve team performance.',
	});

	const options = [
		{
			title: intl.formatMessage({
				id: 'jira-product-tour.collaborate-section.first-feature-title-text',
				defaultMessage: '⚡ Plan and organize tasks',
			}),
			image: getCollaborateFirstImage(intl.locale),
			description: useGWP7617Gate ? firstFeatureDescriptionAI : firstFeatureDescriptionOld,
		},
		{
			title: intl.formatMessage({
				id: 'jira-product-tour.collaborate-section.second-feature-title-text',
				defaultMessage: 'Align work to goals',
			}),
			image: getCollaborateSecondImage(intl.locale),
			description: intl.formatMessage({
				id: 'jira-product-tour.collaborate-section.second-feature-description-text',
				defaultMessage:
					'Link work to goals so everyone can see how their work contributes to company objectives and stay aligned to what’s important.',
			}),
		},
		{
			title: useGWP7617Gate ? thirdFeatureTitleAI : thirdFeatureTitleOld,
			image: getCollaborateThirdImage(intl.locale),
			description: useGWP7617Gate ? thirdFeatureDescriptionAI : thirdFeatureDescriptionOld,
		},
		{
			title: useGWP7617Gate ? fourthFeatureTitleAI : fourthFeatureTitleOld,
			image: getCollaborateFourthImage(intl.locale),
			description: useGWP7617Gate ? fourthFeatureDescriptionAI : fourthFeatureDescriptionOld,
		},
	];

	return (
		<JswCollaborate
			options={options}
			heading={intl.formatMessage({
				id: 'jira-product-tour.collaborate-section.title-text',
				defaultMessage: 'Made for complex projects or everyday tasks',
			})}
		/>
	);
};
JswCollaborateSection.displayName = 'JswCollaborateSection';
